const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/terms-conditions/api-factory');
const serviceFactory = require('../resources/terms-conditions/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/userprofile/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app

  .match(`${p}loginTerms.getPdfLink[{keys:dummyBrch}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
    service.getLoginTerms(req.params)
      .then(response => res.value(response))
      .catch(res.error)
  )))

  .match(`${p}terms.showTermsConditions`, requests => Promise.all(
   requests.map(({ req, res }) =>
    service.showTermsConditions(req.params)
      .then(response => res.value(response))
      .catch(res.error)
  )))

  .match(`${p}terms.saveTermsConditions[{keys:seenTerms}][{keys:seenPrivacy}][{keys:channel}][{keys:termsUrl}][{keys:privacyUrl}][{keys:tcVersion}][{keys:paVersion}]`, requests => Promise.all(

    requests.map(({ req, res }) => {
      if (req.params.termsUrl) req.params.termsUrl = req.params.termsUrl.replace('<dot>', '.');
      if (req.params.privacyUrl) req.params.privacyUrl = req.params.privacyUrl.replace('<dot>', '.');

        return service.saveTermsConditions(req.params)
        .then(response => res.value(response))
        .catch(res.error)
   }
  )))
  .match(`${p}terms.saveTermsConditions[{keys:seenTerms}][{keys:seenPrivacy}][{keys:channel}][{keys:termsUrl}][{keys:privacyUrl}][{keys:tcVersion}][{keys:paVersion}][{keys:termsChatUrl}][{keys:seenChatTerms}][{keys:tcChatVersion}][{keys:seenSummary}]`, requests => Promise.all(

    requests.map(({ req, res }) => {
      if (req.params.termsUrl) req.params.termsUrl = req.params.termsUrl.replace('<dot>', '.');
      if (req.params.privacyUrl) req.params.privacyUrl = req.params.privacyUrl.replace('<dot>', '.');
      if (req.params.termsChatUrl) req.params.termsChatUrl = req.params.termsChatUrl.replace('<dot>', '.');

        return service.saveTermsConditionsExtended(req.params)
        .then(response => res.value(response))
        .catch(res.error)
   }
   )))

  .match(`${p}terms.getTermsConditionsAndRmiaData`, requests => Promise.all(
   requests.map(({ req, res }) =>
    service.getTermsConditionsAndRmiaData(req.params)
      .then(response => res.value(response))
      .catch(res.error)

  )))

  .match(`${p}userProfile.getPaymentLimit[{keys:channel}][{keys:guidStr}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
    {
      return service.getPaymentLimit(req.params)
      .then(response => res.value(response))
      .catch(res.error)
    }
    )));
}

module.exports = addRoutes;
